const assets = {
  payPayLogo: "/paypay_logo.png",
  heroImage: "/potion/hero_image.webp",
};

export default assets;
